import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PendingActions = ({ pendingActions, onActionClick }) => {
  const getPriorityColor = (priority) => {
    const colors = {
      'High': 'bg-error/10 text-error border-error/20',
      'Medium': 'bg-warning/10 text-warning border-warning/20',
      'Low': 'bg-success/10 text-success border-success/20'
    };
    return colors?.[priority] || 'bg-muted/10 text-muted-foreground border-border';
  };

  const getActionIcon = (type) => {
    const icons = {
      'signature_required': 'PenTool',
      'document_review': 'FileText',
      'permission_update': 'Settings',
      'invitation_pending': 'UserPlus',
      'communication_needed': 'MessageSquare'
    };
    return icons?.[type] || 'AlertCircle';
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-soft p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-2">
          <Icon name="AlertTriangle" size={20} className="text-warning" />
          <h3 className="text-lg font-semibold text-foreground">Pending Actions</h3>
        </div>
        <span className="text-sm text-muted-foreground">
          {pendingActions?.length} items require attention
        </span>
      </div>
      <div className="space-y-4 max-h-96 overflow-y-auto">
        {pendingActions?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="CheckCircle" size={48} className="text-success mx-auto mb-3" />
            <p className="text-foreground font-medium">All caught up!</p>
            <p className="text-sm text-muted-foreground">No pending actions at this time.</p>
          </div>
        ) : (
          pendingActions?.map((action) => (
            <div
              key={action?.id}
              className={`border rounded-lg p-4 transition-smooth hover:shadow-soft ${getPriorityColor(action?.priority)}`}
            >
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 mt-0.5">
                  <Icon name={getActionIcon(action?.type)} size={16} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="font-medium text-foreground truncate">{action?.title}</h4>
                    <span className="text-xs font-medium px-2 py-1 rounded-full bg-current/10">
                      {action?.priority}
                    </span>
                  </div>
                  <p className="text-sm text-muted-foreground mb-3">{action?.description}</p>
                  
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4 text-xs text-muted-foreground">
                      <span className="flex items-center space-x-1">
                        <Icon name="User" size={12} />
                        <span>{action?.stakeholder}</span>
                      </span>
                      <span className="flex items-center space-x-1">
                        <Icon name="Clock" size={12} />
                        <span>{action?.dueDate}</span>
                      </span>
                    </div>
                    
                    <Button
                      variant="outline"
                      size="xs"
                      onClick={() => onActionClick(action)}
                      className="text-xs"
                    >
                      Take Action
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
      {pendingActions?.length > 0 && (
        <div className="mt-6 pt-4 border-t border-border">
          <Button variant="outline" size="sm" fullWidth>
            View All Pending Actions
          </Button>
        </div>
      )}
    </div>
  );
};

export default PendingActions;